/* 欅フィルター訴求（Issue#107）
   コレクションで樹種=欅（けやき）だけが選択された時にだけ、フィルター直下に欅の訴求を表示。
   検知：テーマ独自の「現在の絞り込み条件」(.kido-selected__tags li = "樹種：欅（けやき）"形式)を読み、
        選択中の"樹種"が欅（けやき）のみのとき表示。他樹種/複数/未選択は非表示（他樹種に影響なし）。
   Boostのフィルター更新でこの要素が書き換わるのでMutationObserverで追従。 */
(function(){
  "use strict";

  var SPECIES = ['欅（けやき）','楠（くす）','栃（とち）','モンキーポッド','ポプラ','屋久杉',
                 'ウォールナット','桜','栗（くり）','栗','楓','吉野杉','杉','ポプラ（白楊）','神代欅','神代楡','神代杉'];

  function selectedSpecies(){
    var set = {};
    document.querySelectorAll('.kido-selected__tags li').forEach(function(li){
      var parts = (li.textContent||'').split('：');
      var vals = (parts.length>1 ? parts.slice(1).join('：') : '').split(',');
      vals.forEach(function(v){ v=v.trim(); if(SPECIES.indexOf(v)!==-1) set[v]=1; });
    });
    return Object.keys(set);
  }
  function isKeyakiOnly(){
    var s = selectedSpecies();
    return s.length===1 && s[0]==='欅（けやき）';
  }
  // 「神代」（神代欅・神代楡・神代杉 等）が選ばれている時は表示しない
  function hasJindai(){
    var found = false;
    document.querySelectorAll('.kido-selected__tags li').forEach(function(li){
      if ((li.textContent||'').indexOf('神代') !== -1) found = true;
    });
    return found;
  }

  var BLOCK_ID = 'kido-keyaki-filter-msg';
  var GOTHIC = "'Hiragino Kaku Gothic ProN','Hiragino Sans','Yu Gothic',sans-serif";
  function buildBlock(){
    // 白・グレー・黒。ゴシックのみ。囲みボックスなし・エディトリアルな型＋登場アニメで洗練かつ心躍る。
    var el = document.createElement('div');
    el.id = BLOCK_ID;
    el.setAttribute('style',
      'margin:0 0 10px;padding:20px 0 8px;border-top:1px solid #ececec;font-family:'+GOTHIC+';'+
      'opacity:0;transform:translateY(20px);transition:opacity 1.4s ease,transform 1.4s cubic-bezier(.16,.7,.3,1);');
    // 本文はフレーズ単位を white-space:nowrap で包み、折り返しを必ず"キリの良い"位置にする（「を。」だけ残る等を防止）
    var w = function(t){ return '<span style="white-space:nowrap">'+t+'</span>'; };
    el.innerHTML =
      '<div style="font-size:10.5px;letter-spacing:.3em;color:#a6a6a6;margin-bottom:10px;">KEYAKI</div>'+
      '<p style="margin:0 0 9px;font-size:19px;font-weight:700;color:#141414;letter-spacing:.01em;line-height:1.5;">'+
      '欅を選ぶ、という確かさ。</p>'+
      '<p style="margin:0;font-size:13px;line-height:2;color:#6f6f6f;max-width:640px;">'+
      w('日本の広葉樹を代表する銘木・欅。')+
      w('深い木目と重厚な存在感が、')+
      w('空間の中心に静かな格をつくります。')+
      w('わたしたちが')+
      w('<span style="color:#2a2a2a;font-weight:600;">もっとも手をかけてきた樹種</span>——')+
      w('同じ木目は二度と現れない、')+
      w('世界にひとつの一枚を。')+
      '</p>';
    return el;
  }
  function animateIn(el){
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      el.style.opacity='1'; el.style.transform='translateY(0)'; }); });
  }

  function place(el){
    // 結果側の商品グリッド直前に固定（PC=絞り込み条件の下、スマホ=一覧の直前）。
    // フィルター用ドロワー/モーダル内(.kido-selected)には入れない＝スマホの絞り込みモーダルに出さない。
    var grids = document.querySelectorAll('.boost-pfs-filter-products');
    for (var i=0;i<grids.length;i++){
      var grid = grids[i];
      // モーダル/ドロワー配下のものは除外
      if (grid.closest('.boost-pfs-filter-tree-mobile, .boost-pfs-filter-tree-v-mobile, [class*="mobile-modal"], [class*="filter-drawer"]')) continue;
      if (grid.parentNode){
        var summary = document.getElementById('kido-filter-summary');
        // 絞り込み条件の帯(kido-filter-summary)が同じ親にあれば必ずその直後(下)に置く＝欅訴求は常に帯の下
        if (summary && summary.parentNode === grid.parentNode){
          if (summary.nextElementSibling !== el){ grid.parentNode.insertBefore(el, summary.nextSibling); }
        } else {
          if (grid.previousElementSibling !== el){ grid.parentNode.insertBefore(el, grid); }
        }
        return true;
      }
    }
    return false;
  }

  function isMobile(){ return window.innerWidth < 768; }
  // スマホ：「絞り込む」(.boost-pfs-filter-show-result) が押された後のみ表示する。
  //  applied=true → 絞り込む押下済み。モーダルを開き直す/操作すると false に戻し、再度「絞り込む」で true。
  var applied = false;

  var showTimer = null;
  function clearShow(){ if (showTimer){ clearTimeout(showTimer); showTimer = null; } }

  function shouldShow(){
    if (!isKeyakiOnly() || hasJindai()) return false;   // 木の種類=欅のみ・神代なし
    if (isMobile() && !applied) return false;           // スマホは「絞り込む」押下後のみ
    return true;
  }
  function render(){
    var existing = document.getElementById(BLOCK_ID);
    if (shouldShow()){
      if (existing){ place(existing); return; }   // 既に表示中 → 位置補正のみ
      if (showTimer) return;                       // 表示待ち中 → 二重予約しない
      showTimer = setTimeout(function(){
        showTimer = null;
        if (shouldShow() && !document.getElementById(BLOCK_ID)){
          var el = buildBlock();
          if (place(el)) animateIn(el);            // 下からフェードアップ（1.4s）
        }
      }, 1000);                                    // ← 「絞り込む」押下 or 条件成立から約1秒後
    } else {
      clearShow();                                 // 途中で条件が変わったら予約を取り消す
      if (existing) existing.remove();
    }
  }

  function boot(){
    // 初期表示：欅のみで読み込まれた（絞り込み済みURL等）ならスマホでも表示対象にする
    if (isKeyakiOnly() && !hasJindai()) applied = true;
    render();
    // 絞り込み条件表示の変化を監視して追従
    var target = document.querySelector('.boost-pfs-filter-options-wrapper') || document.body;
    try {
      // 内容変化＋パネルの表示切替（モーダル開閉）を捉える
      new MutationObserver(function(){ render(); }).observe(target, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class']});
    } catch(_){}
    // ドロワー開閉（body class変化）を監視 → 閉じた瞬間に下からふわっと再登場
    try {
      new MutationObserver(function(){ render(); }).observe(document.body, {attributes:true, attributeFilter:['class']});
    } catch(_){}
    // 「絞り込む」(.boost-pfs-filter-show-result) 押下＝表示ON。モーダルを開く/×/オーバーレイ＝一旦OFF（選択中は隠す）。
    document.addEventListener('click', function(e){
      if(!e.target || !e.target.closest) return;
      if(e.target.closest('.boost-pfs-filter-show-result')){
        applied = true; setTimeout(render, 400);   // 閉じ＋一覧更新を待って、1秒後に登場
      } else if(e.target.closest('.boost-pfs-filter-custom-filter-button, .boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay')){
        if(isMobile()) applied = false; setTimeout(render, 100);  // モーダルを開く/閉じる操作 → 選択中は隠す
      } else if(e.target.closest('[class*="boost-pfs-filter"]')){
        setTimeout(render, 500);  // その他フィルター操作（PCは即時反映）
      }
    }, true);
    window.addEventListener('popstate', function(){ setTimeout(render, 500); });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot, 800); });
  else setTimeout(boot, 800);
})();
